/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import classname from "classnames";
import { get, cloneDeep, isEmpty, isEqual } from "lodash";
import {
  postPasswordCheck,
  postUsersCert,
  postUsersCertVerify,
  putUsers,
  getUsers,
} from "../../apis/users";
import {
  // allAuthExpire,
  getUser
} from "../../apis/auth";
import { useHistory } from "react-router";
import { enterOnlyNumber } from "../../utils/number";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import Button from "../../components/Button";
import { toast } from "../../utils/toast";

const MyProfile = () => {
  const history = useHistory();
  const user = getUser();
  const [step, setStep] = useState(2);
  const [certPwd, setCertPwd] = useState("");
  const [verifyToken, setVerifyToken] = useState("");
  const [focus, setFoucs] = useState({
    id: false,
    password: false,
    name: false,
    email: false,
    memo: false,
    mobile: false,
  });
  const [initialValues, setInitialValues] = useState({
    id: "",
    name: "",
    email: "",
    memo: "",
    mobile: "",
  });

  useEffect(() => {
    getUsers(user.idx)
      .then((res) => {
        setInitialValues({
          ...get(res, "data.user"),
          password: "",
          pwdCheck: "",
          verifyCode: "",
        });
        setValues({
          ...get(res, "data.user"),
          password: "",
          pwdCheck: "",
          verifyCode: "",
        });
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, [user.idx]);

  const handlePwdCheck = () => {
    postPasswordCheck({ password: certPwd })
      .then(() => {
        setStep(2);
      })
      .catch((err) => {
        systemAlert(get(err, "response.data.message"))
      });
  };

  const handleOnFocus = (e) => {
    const { name } = e.target;
    setFoucs({
      ...focus,
      [name]: true,
    });
  };

  const handleOnBlur = (e) => {
    const { name } = e.target;
    setFoucs({
      ...focus,
      [name]: false,
    });
  };

  const mobileCert = (e) => {
    e.preventDefault();
    // TODO 인증 시간
    postUsersCert({ mobile: values.mobile })
      .then((res) => {
        systemAlert("인증번호를 발송하였습니다.")
      })
      .catch((err) => {
        console.error(err.response);
        systemAlert(get(err, "response.data.message"))
      });
  };

  const mobilecertCheck = (e) => {
    e.preventDefault();
    if (!values.verifyCode) return;
    // TODO ERROR 처리
    postUsersCertVerify({
      mobile: values.mobile,
      verifyCode: values.verifyCode,
    })
      .then((res) => {
        setVerifyToken(get(res, "data.verifyToken"));
      })
      .catch((err) => {
        console.error(err.response);
        systemAlert(get(err, "response.data.message"))
      });
  };

  const validate = ({ name, email, mobile }) => {
    let errors = {};
    const regPwd = /^.*(?=^.{6,12}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/;
    const regEmail = /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/;

    if (!isEmpty(values.password)) {
      if (!regPwd.test(values.password)) {
        errors.password = "영문자, 숫자, 특수문자 조합 6~12자로 설정해주세요";
      }
    }

    if (values.password !== values.pwdCheck) {
      errors.pwdCheck = "비밀번호가 동일하지 않습니다.";
    }

    if (!name) {
      errors.name = "이름은 필수입니다.";
    }

    if (!email) {
      errors.email = "이메일은 필수입니다.";
    } else if (!regEmail.test(values.email)) {
      errors.email = "올바른 이메일 주소를 입력하세요.";
    }

    if (!mobile) {
      errors.mobile = "휴대폰번호는 필수입니다.";
    }

    return errors;
  };

  const submit = (values) => {
    let userInfo = cloneDeep(values);
    if (isEmpty(values.password)) delete userInfo.password;
    if (isEmpty(values.memo)) delete userInfo.memo;
    if (initialValues.mobile === userInfo.mobile) {
      // 폰번호 같음
      delete userInfo.mobile;
      delete userInfo.verifyCode;
      delete userInfo.pwdCheck;
    } else {
      // 폰번호 수정시
      if (!verifyToken) {
        systemAlert("휴대폰번호를 인증해 주세요.")
        return;
      }

      userInfo = {
        ...userInfo,
        verifyToken: verifyToken,
      };
    }

    putUsers(user.idx, userInfo)
      .then(() => {
        toast.success('회원 정보가 수정되었습니다.')
        history.push("/");
      })
      .catch((err) => {
        systemAlert(get(err, "response.data.message"))
      });
  }

  const {
    values,
    setValues,
    errors,
    handleOnChange,
    handleSubmit
  } = useForm({},
    submit,
    validate,
  );

  return (
    <div className="page-layout">
      <div className="Profile">
        {step === 1 && (
          <>
            <h1>비밀번호 확인</h1>
            <div className="first-step-wrap">
              <input
                className="password-check"
                placeholder="비밀번호를 입력해주세요"
                type="password"
                onChange={(e) => setCertPwd(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handlePwdCheck()
                  }
                }}
              />
            </div>
            <div className="button-wrap">
              <Button label="다음" className="button" onClick={handlePwdCheck} disabled={isEmpty(certPwd)} />
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <h1>
              나의 정보 변경
              {/* TODO 전체 로그아웃 */}
              {/* <Button onClick={allAuthExpire}>전체 로그아웃</Button> */}
            </h1>
            <form onSubmit={handleSubmit}>
              <div className="edit-form">
                <div
                  className={classname("form-info-wrap", {
                    focus: get(focus, "id"),
                  })}
                >
                  <label>아이디</label>
                  <div className="input-wrap">
                    <input
                      name="id"
                      placeholder="아이디를 입력해주세요"
                      value={values.id}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                      disabled
                    />
                  </div>
                </div>
                <div className="divider" />
                <div
                  className={classname("form-info-wrap", {
                    focus: get(focus, "password") || get(focus, "pwdCheck"),
                  })}
                >
                  <label>비밀번호</label>
                  <div className="input-wrap">
                    <input
                      name="password"
                      type="password"
                      placeholder="비밀번호를 입력해주세요"
                      value={values.password}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                    />
                    {errors.password && (
                      <p className="error-msg">{errors.password}</p>
                    )}
                  </div>
                  <div className="input-wrap repeat">
                    <input
                      name="pwdCheck"
                      type="password"
                      placeholder="비밀번호를 다시 입력해주세요"
                      value={values.pwdCheck}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                    />
                    {errors.pwdCheck && (
                      <p className="error-msg">{errors.pwdCheck}</p>
                    )}
                  </div>
                </div>
                <div className="divider" />
                <div
                  className={classname("form-info-wrap", {
                    focus: get(focus, "name"),
                  })}
                >
                  <label>이름</label>
                  <div className="input-wrap">
                    <input
                      name="name"
                      placeholder="이름을 입력해주세요"
                      value={values.name}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                    />
                    {errors.name && <p className="error-msg">{errors.name}</p>}
                  </div>
                </div>
                <div className="divider" />
                <div
                  className={classname("form-info-wrap", {
                    focus: get(focus, "email"),
                  })}
                >
                  <label>이메일</label>
                  <div className="input-wrap">
                    <input
                      name="email"
                      placeholder="이메일을 입력해주세요"
                      value={values.email}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                    />
                    {errors.email && (
                      <p className="error-msg">{errors.email}</p>
                    )}
                  </div>
                </div>
                {/* <div className="divider" />
                <div
                  className={classname("form-info-wrap", {
                    focus: get(focus, "memo"),
                  })}
                >
                  <label>메모<span className="label-sub">(선택)</span></label>
                  <div className="input-wrap">
                    <input
                      name="memo"
                      placeholder="남기실 메모가 있으면 입력해주세요"
                      value={values.memo}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                    />
                  </div>
                </div> */}
                <div className="divider" />
                <div
                  className={classname("form-info-wrap", {
                    focus: get(focus, "mobile") || get(focus, "verifyCode"),
                  })}
                >
                  <label>휴대폰번호</label>
                  <div className="input-wrap">
                    <input
                      name="mobile"
                      placeholder="휴대폰번호를 입력해주세요"
                      value={values.mobile}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                      onKeyDown={enterOnlyNumber}
                    />
                    {errors.mobile && (
                      <p className="error-msg">{errors.mobile}</p>
                    )}
                    <Button
                      label="번호인증"
                      color="line"
                      size="sm"
                      className="cert-button"
                      onClick={mobileCert}
                      disabled={initialValues.mobile === values.mobile}
                    />
                  </div>
                  <div className="input-wrap repeat">
                    <input
                      name="verifyCode"
                      placeholder="인증번호를 입력해주세요"
                      value={values.verifyCode}
                      onChange={handleOnChange}
                      onFocus={handleOnFocus}
                      onBlur={handleOnBlur}
                      disabled={initialValues.mobile === values.mobile}
                    />
                    <Button
                      label="인증확인"
                      color="line"
                      size="sm"
                      className="cert-button"
                      onClick={mobilecertCheck}
                      disabled={initialValues.mobile === values.mobile}
                    />
                  </div>
                </div>
              </div>
              <Button
                label="정보변경"
                className="w-full mt-24"
                size="lg"
                onClick={handleSubmit}
                disabled={isEqual(initialValues, values)}
              />
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default MyProfile;
